import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Stack,
    CircularProgress,
    Snackbar,
    Alert,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const NotificationCard = () => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                'https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/tis_notification_get'
            );
            console.log('API response:', response.data);

            // Access nested notifications array in your response
            const items = response?.data?.['body-json']?.body?.notifications || [];

            if (!Array.isArray(items)) {
                console.warn('Parsed notifications is not an array:', items);
                setNotifications([]);
            } else {
                setNotifications(items);
            }
        } catch (err) {
            console.error('Failed to fetch notifications:', err);
            setSnackbar({ open: true, message: 'Failed to load notifications.', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this notification?');
        if (!confirmDelete) return;

        try {
            await axios.post(
                'https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/delete_tis_notification',
                { id }
            );
            setSnackbar({ open: true, message: 'Notification deleted successfully!', severity: 'success' });
            fetchNotifications(); // refresh the list after deletion
        } catch (err) {
            console.error('Delete failed:', err);
            setSnackbar({ open: true, message: 'Failed to delete notification.', severity: 'error' });
        }
    };

    // const handleEdit = (item) => {
    //     navigate('/notification/form', { state: { notification: item } });
    // };

    return (
        <Box sx={{ p: 1, bgcolor: '#f5f7fc', minHeight: '100vh',}}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end',  }}>
                <Button
                    variant="contained"
                    onClick={() => navigate('/notification/form')}
                    sx={{
                        bgcolor: 'primary.main',
                        borderRadius: 5,
                        fontSize:12,
                        fontWeight: 'bold',
                        boxShadow: 2,
                    }}
                >
                    Add Notification
                </Button>
            </Box>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
                    <CircularProgress />
                </Box>
            ) : Array.isArray(notifications) && notifications.length === 0 ? (
                <Typography>No notifications found.</Typography>
            ) : (
                Array.isArray(notifications) &&
                notifications.map((item, index) => (
                    <Card
                        key={item.id || index}
                        sx={{ maxWidth: 400, p: 2, borderRadius: 3, boxShadow: 3, mb: 3 }}
                    >
                        <CardContent>
                            <Typography variant="body1" fontWeight="bold">
                                Created At:{' '}
                                <span style={{ fontWeight: 'normal' }}>
                                    {item.tstamp
                                        ? new Date(Number(item.tstamp)).toLocaleString()
                                        : item.dateTime
                                            ? new Date(item.dateTime).toLocaleString()
                                            : 'N/A'}
                                </span>
                            </Typography>
                            <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                                Expires At:{' '}
                                <span style={{ fontWeight: 'normal' }}>
                                    {item.dateTime ? new Date(item.dateTime).toLocaleString() : 'N/A'}
                                </span>
                            </Typography>

                            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                                {item.message}
                            </Typography>

                            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                                <IconButton
                                    onClick={() => handleDelete(item.id)}
                                    sx={{ bgcolor: '#f44336', color: '#fff' }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                                {/* <IconButton onClick={() => handleEdit(item)} sx={{ bgcolor: '#e0e0e0' }}>
                                    <EditIcon />
                                </IconButton> */}
                            </Stack>
                        </CardContent>
                    </Card>
                ))
            )}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default NotificationCard;
